// extracted by mini-css-extract-plugin
export var image = "image-module--image--afe0e";